module.exports = __webpack_public_path__ + "img/sidebar.fcd9495c.jpg";